<template>
    <div id="pdf-content">
      <div class="pdf-container">
        <!-- INGLES -->
        <div class="pdf-page-break"> <!-- pagina 1 -->
          <div>
            <h1>Collaboration Contract – Freelance Booker</h1>
          </div>
          <p>
            Between the undersigned:
          </p>
          <p>
          <ol>
            <li>
              <span class="number">1.</span>
              VIVASYNC MARKETING CONSULTANCY - FZCO, acting on behalf of the company AIVONI, 
              operating the Oliverlist platform, with its registered office located at Building A1,
              Dubai Digital Park, Dubai Silicon Oasis, Dubai, United Arab Emirates, represented
              by Thibault Pons de Vincent in his capacity as General Manager, duly authorized for
              the purposes hereof, hereinafter referred to as "the Company."
            </li>
          </ol>
          </p>
          <p>
            And
          </p>
          <p>
          <ol>
            <li>
              <span class="number">2.</span>
              <!-- VARIABLE NOMBRE DEL BOOKER -->
              {{ booker.nameBooker }}, acting as an independent contractor, hereinafter referred to as "the Booker."
            </li>
          </ol>
          </p>
          <p>
            The following has been agreed upon:
          </p>
          <hr>
          <p>
            Article 1: Purpose of the Contract
          </p>
          <p>
            The purpose of this contract is to define the terms of collaboration between the 
            Company and the Booker for conducting sales prospecting calls and scheduling business 
            appointments on behalf of the clients of the Oliverlist platform.
          </p>
          <p>
            The Booker's mission is to call the prospects identified through the email prospecting 
            campaigns sent by Oliverlist. These prospects initially receive the emails and have the 
            opportunity to schedule an appointment on their own. If the prospects do not schedule an 
            appointment themselves, the Booker is responsible for contacting them by phone to persuade 
            them to set up a meeting with the Company's clients.
          </p>
          <p>
            The Oliverlist platform synchronizes the clients’ calendars, thereby providing access to 
            their availability. The Booker uses a scheduling link similar to Calendly to book appointments 
            directly into the client’s calendar. This is how business appointments are confirmed and assigned.
          </p>
          <hr>
          <p>
            Article 2: Obligations of the Booker
          </p>
          <p>
            <ol>
              <li>
                <span class="number">1.</span>
                Use of the Oliverlist platform:
                  <ul>
                    <li>
                      <span class="number">°</span>
                      The Booker will be assigned a user account granting access to the Leadroom tab, where they will perform:
                      <ol>
                        <li>
                          <span class="number">-</span>
                          Responses to prospecting emails.
                        </li>
                        <li>
                          <span class="number">-</span>
                          Prospecting calls with the goal of scheduling business appointments.
                        </li>
                      </ol> 
                    </li>
                  </ul>
              </li>
              <li>
                <span class="number">2.</span>
                Working hours:
                  <ol>
                    <li>
                      <span class="number">°</span>
                      The Booker agrees to work during the following hours:
                      <ol>
                        <li>
                          <span class="number">-</span>
                          <strong>Monday: </strong>
                            <span v-if="booker.Monday.length">
                              <span v-for="(hour, index) in booker.Monday">
                                {{ index > 0 ? ', ' : '' }}from {{ hour.from }}h to {{ hour.to }}h
                              </span>
                            </span>
                        </li>
                        <li>
                          <span class="number">-</span>
                          <strong>Tuesday: </strong>
                            <span v-if="booker.Tuesday.length">
                              <span v-for="(hour, index) in booker.Tuesday">
                                {{ index > 0 ? ', ' : '' }}from {{ hour.from }}h to {{ hour.to }}h
                              </span>
                            </span>
                        </li>
                        <li>
                          <span class="number">-</span>
                          <strong>Wednesday: </strong>
                            <span v-if="booker.Wednesday.length">
                              <span v-for="(hour, index) in booker.Wednesday">
                                {{ index > 0 ? ', ' : '' }}from {{ hour.from }}h to {{ hour.to }}h
                              </span>
                            </span>
                        </li>
                        <li>
                          <span class="number">-</span>
                          <strong>Thursday: </strong>
                            <span v-if="booker.Thursday.length">
                              <span v-for="(hour, index) in booker.Thursday">
                                {{ index > 0 ? ', ' : '' }}from {{ hour.from }}h to {{ hour.to }}h
                              </span>
                            </span>
                        </li>
                        <li>
                          <span class="number">-</span>
                          <strong>Friday: </strong>
                            <span v-if="booker.Friday.length">
                              <span v-for="(hour, index) in booker.Friday">
                                {{ index > 0 ? ', ' : '' }}from {{ hour.from }}h to {{ hour.to }}h
                              </span>
                            </span>
                        </li>
                      </ol> 
                    </li>
                    <li>
                      <span class="number">°</span>
                      These working hours will be configured in the Booker’s account on the Oliverlist platform.
                    </li>
                  </ol>
              </li>
            </ol>
          </p>
        </div>
        <div class="pdf-page-break"> <!-- pagina 2 -->
          <p>
            <ol>
              <li>
                <span class="number">3.</span>
                Attendance:
                <ol>
                  <li>
                    <span class="number">°</span>
                      An hour of work is counted if and only if at least 20
                      tasks checked or 5 calls answered were completed during that
                      hour.
                  </li>
                  <li>
                    <span class="number">°</span>
                    A task is considered verified only if it corresponds to a phone call made 
                    to a prospect or an email sent to a prospect. Incomplete or unexecuted actions 
                    are not counted.
                  </li>
                  <li>
                    <span class="number">°</span>
                    A margin of 20% is accepted.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
          <hr>
          <p>
            Article 3: Compensation and Advancement
          </p>
          <p>
            <ol>
              <li>
                <span class="number">a. </span>
                Start of assignment: This contract is signed upon validation of the Booker’s application, and access to the application may be granted on a preparatory basis.
              </li>
            </ol>
          </p>
          <p>
            However, the official start date of the contract and compensation only takes effect once the Booker reaches Booker Level <span v-if="['Booker Manager', 'Booker France'].includes(booker.bookerStatus)">2</span><span v-else>1</span> status.
          </p>
          <p>
            <ol>
              <li>
                <span class="number">b. </span>
                Fixed salary: Upon onboarding, the Booker chooses to work either full-time or part-time.
                <ol>
                  <li>
                    <span class="number">- </span>
                    Full-time: the Booker receives 100% of the fixed salary provided for their level.
                  </li>
                  <li>
                    <span class="number">- </span>
                    Part-time: the Booker receives 50% of the fixed salary provided for their level.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
          <p>
            The fixed salary is only activated if the Booker schedules at least 1 meeting during the current month. 
            This amount is adjusted according to the consistency rate (attendance):
            <ol>
              <li>
                <span class="number">- </span>
                80% to 100% consistency → 100% of the fixed salary.
              </li>
              <li>
                <span class="number">- </span>
                Less than 80% → fixed salary weighted by the consistency rate.
              </li>
            </ol>
          </p>
          <p>
            <ol>
              <li>
                <span class="number">c. </span>
                Commissions and progression: the Booker advances according to their progression:
              </li>
              <li v-if="!['Booker Manager', 'Booker France'].includes(booker.bookerStatus)">
                <span class="number">- </span>
                Level 1: €300 fixed + €7 per validated meeting.
              </li>
              <li>
                <span class="number">- </span>
                Level 2: €500 fixed + €7 per validated meeting.
              </li>
              <li>
                <span class="number">- </span>
                Level 3: €600 fixed + €10 per validated meeting.
              </li>
              <li>
                <span class="number">- </span>
                Level 4: €700 fixed + €14 per validated meeting.
              </li>
            </ol>
          </p>
          <p>
            <ol>
              <li>
                <span class="number">d. </span>
                Advancement conditions:
              </li>
              <li>
                <span class="number">- </span>
                By seniority and volume:
                <ol>
                  <li>
                    <span class="number">- </span>
                    Promotion to Level 3 after 6 months + 80 meetings achieved.
                  </li>
                  <li>
                    <span class="number">- </span>
                    Promotion to Level 4 after 12 months + 160 meetings achieved.
                  </li>
                </ol>
              </li>
              <li>
                <span class="number">- </span>
                By exceptional performance (possible fast-track):
                <ol>
                  <li>
                    <span class="number">- </span>
                    Automatic promotion to Level 3 if the meeting rate ≥ 1% over a full month.
                  </li>
                  <li>
                    <span class="number">- </span>
                    Automatic promotion to Level 4 if the meeting rate ≥ 1,5% over a full month.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
          <p>
            <ol>
              <li>
                <span class="number">e. </span>
                Performance bonuses:
              </li>
              <li>
                <span class="number">- </span>
                Quality: if the no-show meeting rate is < 15% → commissions are doubled.
              </li>
              <li>
                <span class="number">- </span>
                Volume: if the Booker schedules 15 meetings in a month → commissions are doubled.
              </li>
            </ol>
          </p>
          <p>
            If the no-show meeting rate exceeds 50% → immediate termination possible.
          </p>
          <hr>
        </div>
        <div class="pdf-page-break"> <!-- pagina 3 -->
          <p>
            Article 4: Supervision by a Manager
          </p>
          <p>
            Starting from Level <span v-if="['Booker Manager', 'Booker France'].includes(booker.bookerStatus)">2</span><span v-else>1</span> status, the Booker benefits from the support of a Manager.
            The Manager is an experienced Booker, responsible for providing advice, best practices,
            and support to improve the Booker's results.
          </p>
          <hr>
          <p>
            Article 5 : Training and Profile Validation
          </p>
          <p>
            The Booker has access to an onboarding process including:
          </p>
          <p>
            <ol>
              <li>
                <span class="number">-</span>
                Videos illustrating real cases.
              </li>
              <li>
                <span class="number">-</span>
                The Merci Hubert knowledge base with detailed procedures.
              </li>
            </ol>
          </p>
          <p>
            The Booker must pass a theoretical test (≥ 45/50) and then a practical trial day before being confirmed.
          </p>
          <hr>
          <p>
            Article 6: Confidentiality
          </p>
          <p>
            <ol>
              <li>
                <span class="number">1. </span>
                Confidentiality of the platform and technologies used:
                <ol>
                  <li>
                    <span class="number">°</span>
                    The Oliverlist platform and the technologies used for prospecting are 
                    strictly confidential.
                  </li>
                  <li>
                    <span class="number">°</span>
                    The Booker agrees never to disclose, transmit, or share any information related to 
                    the methodologies, processes, or technologies used by Oliverlist, either during or 
                    after the end of the collaboration.
                  </li>
                </ol>
              </li>
              <li>
                <span class="number">2. </span>
                Confidentiality of Oliverlist’s clients:
                <ol>
                  <li>
                    <span class="number">°</span>
                    The Booker agrees to maintain the strictest confidentiality regarding Oliverlist’s clients.
                  </li>
                  <li>
                    <span class="number">°</span>
                    The Booker is strictly prohibited from disclosing to any third party information about the 
                    identity of the clients, the nature of their activities, or the services provided by Oliverlist.
                  </li>
                </ol>
              </li>
              <li>
                <span class="number">3. </span>
                Sanctions in case of breach:
                <ol>
                  <li>
                    <span class="number">°</span>
                    Any breach of confidentiality obligations may result in immediate termination of the 
                    contract, without notice or compensation.
                  </li>
                  <li>
                    <span class="number">°</span>
                    The Company reserves the right to take legal action in case of damages resulting 
                    from unauthorized disclosure.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
          <hr>
          <p>
            Article 7: Termination
          </p>
          <p>
            <ol>
              <li>
                <span class="number">1) </span>
                Performance-based pay:
                <ol>
                  <li>
                    <span class="number">a) </span>
                    The fixed salary shall only be activated if:
                    <ol>
                      <li>
                        <span class="number">i.</span>
                        The Booker's remuneration is strictly conditional upon the completion of at least <strong>one (1) booked meeting 
                        (meetings that do not meet the minimum conditions established by the quality control department shall not count)</strong>
                        during the current monthly period.
                      </li>
                      <li>
                        <span class="number">ii.</span>
                        In the event that the Booker fails to generate at least one meeting during the month, <strong>no remuneration whatsoever shall be due</strong> by the Company to the Booker for said period.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
          </p>
        </div>
        <div class="pdf-page-break"> <!-- pagina 4 -->
          <p>
            <ol>
              <li>
                <ol>
                  <li>
                    <span class="number">b)</span>
                      Once the Booker has reached Level 2, the previous condition continues to apply in addition to the following conditions for unlocking the fixed salary:
                      <ol>
                        <li>
                          <span class="number">i)</span>
                            If the Booker does not obtain at least <strong>1 validated meeting</strong> in the current month, the fixed salary will be calculated on the basis of €100.
                        </li>
                        <li>
                          <span class="number">ii)</span>
                            Upon obtaining 1 validated meeting in the current month, the fixed salary will be calculated at 50% of the reference fixed salary corresponding to the Booker's status.
                        </li>
                        <li>
                          <span class="number">iii)</span>
                            Upon obtaining 2 validated meetings in the current month, the fixed salary will be calculated at 100% of the reference fixed salary corresponding to the Booker's status.
                        </li>
                      </ol>
                      A <em>validated meeting</em> means a commercial appointment that has actually been attended by both the client and the prospect and has been duly invoiced by the Company.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
          <p>
            <ol>
              <li>
                <span class="number">2. </span>
                Termination for lack of results:
                <ol>
                  <li>
                    <span class="number">°</span>
                    If the Booker does not generate <strong>any validated meeting during a full calendar month</strong>, the Company reserves the right to terminate this contract early, <strong>without notice and without any compensation or indemnity</strong>.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
          <p>
            <ol>
              <li>
                <span class="number">3. </span>
                Qualitative or operational breaches:
                <ol>
                  <li>
                    <span class="number">°</span>
                    Regardless of results, in the event of failure to comply with attendance obligations, call quality standards, or internal procedures, the Company may terminate the contract <strong>without notice</strong>.
                  </li>
                </ol>
              </li>
              <li>
                <span class="number">4. </span>
                Termination at the Booker’s initiative:
                <ol>
                  <li>
                    <span class="number">°</span>
                    The Booker may terminate this contract by giving 15 days’ prior notice.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
          <hr>
          <p>
            Article 8: General Provisions
          </p>
          <p>
            <ol>
              <li>
                <span class="number">1. </span>
                Status of the Booker:
                <ol>
                  <li>
                    <span class="number">°</span>
                    The Booker acts as a freelancer and is not bound to the Company by an employment contract.
                  </li>
                  <li>
                    <span class="number">°</span>
                    They are responsible for their own tax and social security declarations.
                  </li>
                </ol>
              </li>
              <li>
                <span class="number">2. </span>
                Responsibilities regarding equipment:
                <ol>
                  <li>
                    <span class="number">°</span>
                    The Booker is responsible for providing and funding their own Internet connection 
                    and the necessary equipment to carry out their tasks, including, but not limited to, 
                    a computer, headphones, and any other required equipment.
                  </li>
                </ol>
              </li>
              <li>
                <span class="number">3. </span>
                Public Holidays:
                <ol>
                  <li>
                    <span class="number">°</span>
                    The Booker is entitled to French public holidays only and is not required to work on those days.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
        <hr>
        </div>
        <div class="pdf-page-break"> <!-- pagina 5 -->
          <p>
            Done in Paris, on {{ formatDate(booker.date) }}.
          </p>
          <p>
            For VIVASYNC MARKETING CONSULTANCY:
          </p>
          <img src="@/assets/images/booker/firma_contrato_booker.png" class="pdf-firma">
          <p>
            Thibault Pons de Vincent
          </p>
          <p>
            For the Booker: {{ booker.nameBooker }}
          </p>
        </div>
  
        <!-- FIN INGLES -->
        <!-- FRANCES -->
        <div class="pdf-page-break"> <!-- pagina 1 -->
          <div>
            <h1>Contrat de Collaboration – Booker Freelance</h1>
          </div>
          <p>
            Entre les soussignés :
          </p>
          <p>
          <ol>
            <li>
              <span class="number">1.</span>
              VIVASYNC MARKETING CONSULTANCY - FZCO, agissant pour le compte de la Société AIVONI, 
              exploitant la plateforme Oliverlist, dont le siège social est situé à Building A1, Dubai Digital Park, 
              Dubai Silicon Oasis, Dubai, United Arab Emirates, représentée par Thibault Pons de Vincent, 
              en tant que General Manager, dûment habilitée aux fins des présentes, ci-après dénommée "la Société".
            </li>
          </ol>
          </p>
          <p>
            Et
          </p>
          <p>
          <ol>
            <li>
              <span class="number">2.</span>
              <!-- VARIABLE NOMBRE DEL BOOKER -->
              {{ booker.nameBooker }}, agissant en qualité de travailleur indépendant, ci-après dénommé "le Booker".
            </li>
          </ol>
          </p>
          <p>
            Il a été convenu ce qui suit :
          </p>
          <hr>
          <p>
            Article 1 : Objet du Contrat
          </p>
          <p>
            Le présent contrat a pour objet de définir les conditions de collaboration entre la Société et le 
            Booker pour la réalisation d’appels de prospection commerciale et la programmation de rendez-vous 
            commerciaux pour le compte des clients de la plateforme Oliverlist.
          </p>
          <p>
            La mission du Booker consiste à appeler les prospects identifiés par les campagnes d’emails de 
            prospection envoyés par Oliverlist. Les prospects reçoivent initialement ces emails et ont la 
            possibilité de prendre rendez-vous de manière autonome. Si les prospects ne prennent pas rendez-vous 
            eux-mêmes, le Booker est chargé de les contacter par téléphone afin de les convaincre de planifier un rendez-vous 
            avec les clients de la Société.
          </p>
          <p>
            La plateforme Oliverlist synchronise les agendas des clients, donnant ainsi accès aux disponibilités 
            des clients. Le Booker utilise un lien de prise de rendez-vous de type Calendly pour programmer les 
            rendez-vous directement dans l’agenda du client. C’est ainsi que les rendez-vous commerciaux sont validés et attribués.
          </p>
          <hr>
          <p>
            Article 2 : Obligations du Booker
          </p>
          <p>
            <ol>
              <li>
                <span class="number">1.</span>
                Utilisation de la plateforme Oliverlist :
                  <ul>
                    <li>
                      <span class="number">°</span>
                      Le Booker se verra attribuer un compte utilisateur lui permettant d’accéder à l’onglet Leadroom, où il effectuera :
                      <ol>
                        <li>
                          <span class="number">-</span>
                          Des réponses à des emails de prospection.
                        </li>
                        <li>
                          <span class="number">-</span>
                          Des appels de prospection dans le but de programmer des rendez-vous commerciaux.
                        </li>
                      </ol> 
                    </li>
                  </ul>
              </li>
              <li>
                <span class="number">2.</span>
                Horaires de travail :
                  <ol>
                    <li>
                      <span class="number">°</span>
                      Le Booker s’engage à travailler aux horaires suivants :
                      <ol>
                        <li>
                          <span class="number">-</span>
                          <strong>lundi: </strong>
                            <span v-if="booker.Monday.length">
                              <span v-for="(hour, index) in booker.Monday">
                                {{ index > 0 ? ', ' : '' }}de {{ hour.from }}h à {{ hour.to }}h
                              </span>
                            </span>
                        </li>
                        <li>
                          <span class="number">-</span>
                          <strong>Mardi: </strong>
                            <span v-if="booker.Tuesday.length">
                              <span v-for="(hour, index) in booker.Tuesday">
                                {{ index > 0 ? ', ' : '' }}de {{ hour.from }}h à {{ hour.to }}h
                              </span>
                            </span>
                        </li>
                        <li>
                          <span class="number">-</span>
                          <strong>Mercredi: </strong>
                            <span v-if="booker.Wednesday.length">
                              <span v-for="(hour, index) in booker.Wednesday">
                                {{ index > 0 ? ', ' : '' }}de {{ hour.from }}h à {{ hour.to }}h
                              </span>
                            </span>
                        </li>
                        <li>
                          <span class="number">-</span>
                          <strong>Jeudi: </strong>
                            <span v-if="booker.Thursday.length">
                              <span v-for="(hour, index) in booker.Thursday">
                                {{ index > 0 ? ', ' : '' }}de {{ hour.from }}h à {{ hour.to }}h
                              </span>
                            </span>
                        </li>
                        <li>
                          <span class="number">-</span>
                          <strong>Vendredi: </strong>
                            <span v-if="booker.Friday.length">
                              <span v-for="(hour, index) in booker.Friday">
                                {{ index > 0 ? ', ' : '' }}de {{ hour.from }}h à {{ hour.to }}h
                              </span>
                            </span>
                        </li>
                      </ol> 
                    </li>
                    <li>
                      <span class="number">°</span>
                      Ces horaires seront configurés dans le compte du Booker sur la plateforme Oliverlist.
                    </li>
                  </ol>
              </li>
            </ol>
          </p>
        </div>
        <div class="pdf-page-break">         <!-- pagina 2 -->
          <p>
            <ol>
              <li>
                <span class="number">3.</span>
                Assiduité :
                <ol>
                  <li>
                    <span class="number">°</span>
                      Une heure de travail est comptabilisée si et seulement si au moins 20
                      tâches vérifiées ou 5 appels décrochés ont été effectuées durant cette
                      heure.
                  </li>
                  <li>
                    <span class="number">°</span>
                    Une tâche est considérée comme vérifiée uniquement si elle correspond à un 
                    appel téléphonique passé à un prospect ou un email envoyé à un prospect. 
                    Les actions incomplètes ou non exécutées ne sont pas comptabilisées.
                  </li>
                  <li>
                    <span class="number">°</span>
                    Une marge de 20% est acceptée.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
          <hr>
          <p>
            Article 3 : Rémunération et Évolution
          </p>
          <p>
            <ol>
              <li>
                <span class="number">a. </span>
                Début de mission : Le présent contrat est signé dès validation de la candidature du 
                Booker et son accès à l’application peut être activé à titre préparatoire.
              </li>
            </ol>
          </p>
          <p>
            Toutefois, la date effective de début du contrat et de la rémunération ne prend effet 
            qu’à partir du moment où le Booker obtient le statut Booker Level  <span v-if="['Booker Manager', 'Booker France'].includes(booker.bookerStatus)">2</span><span v-else>1</span>.
          </p>
          <p>
            <ol>
              <li>
                <span class="number">b. </span>
                Salaire fixe : le Booker choisit, lors de son intégration, de travailler à temps plein ou à temps partiel.
                <ol>
                  <li>
                    <span class="number">- </span>
                    Temps plein : le Booker perçoit 100 % du salaire fixe prévu pour son niveau
                  </li>
                  <li>
                    <span class="number">- </span>
                    Temps partiel : le Booker perçoit 50 % du salaire fixe prévu pour son niveau.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
          <p>
            Le salaire fixe est activé uniquement si le Booker programme au moins 1 rendez-vous durant le mois en cours. 
            Ce montant est ajusté en fonction du taux de consistency (assiduité) :
            <ol>
              <li>
                <span class="number">- </span>
                80% à 100% de consistency → 100% du fixe.
              </li>
              <li>
                <span class="number">- </span>
                Moins de 80% → fixe pondéré par le taux de consistency
              </li>
            </ol>
          </p>
          <p>
            <ol>
              <li>
                <span class="number">c .</span>
                Commissions et progression : le Booker évolue en fonction de sa progression :
              </li>
              <li v-if="!['Booker Manager', 'Booker France'].includes(booker.bookerStatus)">
                <span class="number">- </span>
                Level 1 : 300€ fixe + 7€/meeting validé.
              </li>
              <li>
                <span class="number">- </span>
                Level 2 : 500€ fixe + 7€/meeting validé.
              </li>
              <li>
                <span class="number">- </span>
                Level 3 : 600€ fixe + 10€/meeting validé.
              </li>
              <li>
                <span class="number">- </span>
                Level 4 : 700€ fixe + 14€/meeting validé.
              </li>
            </ol>
          </p>
          <p>
            <ol>
              <li>
                <span class="number">d .</span>
                Conditions d’évolution :
              </li>
              <li>
                <span class="number">- </span>
                Par ancienneté et volume :
                <ol>
                  <li>
                    <span class="number">- </span>
                    Passage au Level 3 après 6 mois + 80 meetings atteints.
                  </li>
                  <li>
                    <span class="number">- </span>
                    Passage au Level 4 après 12 mois + 160 meetings atteints.
                  </li>
                </ol>
              </li>
              <li>
                <span class="number">- </span>
                Par performance exceptionnelle (saut possible) :
                <ol>
                  <li>
                    <span class="number">- </span>
                    Passage automatique Level 3 si le meeting rate ≥ 1% sur un mois complet.
                  </li>
                  <li>
                    <span class="number">- </span>
                    Passage automatique Level 4 si le meeting rate ≥ 1,5% sur un mois complet.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
          <p>
            <ol>
              <li>
                <span class="number">e .</span>
                Bonus de performance :
              </li>
              <li>
                <span class="number">- </span>
                Qualité : si le taux de rendez-vous non honorés est < 15% → commissions doublées.
              </li>
              <li>
                <span class="number">- </span>
                Volume : si le Booker atteint 15 meetings programmés dans le mois → commissions doublées.
              </li>
            </ol>
          </p>
          <p>
            Si le taux de rendez-vous non honorés dépasse 50% → résiliation immédiate possible.
          </p>
          <hr>
        </div>
        <div class="pdf-page-break"> <!-- pagina 3 -->
          <p>
            Article 4 : Encadrement par un Manager
          </p>
          <p>
            À partir du statut Level <span v-if="['Booker Manager', 'Booker France'].includes(booker.bookerStatus)">2</span><span v-else>1</span>, le Booker bénéficie de l’accompagnement d’un Manager. 
            Le Manager est un Booker expérimenté, chargé de donner conseils, bonnes pratiques 
            et soutien afin d’améliorer les résultats du Booker.
          </p>
          <hr>
          <p>
            Article 5 : Formation et Validation du Profil
          </p>
          <p>
            Le Booker a accès à un parcours d’onboarding comprenant :
          </p>
          <p>
            <ol>
              <li>
                <span class="number">-</span>
                Des vidéos illustrant des cas réels.
              </li>
              <li>
                <span class="number">-</span>
                La base de connaissances Merci Hubert avec procédures détaillées.
              </li>
            </ol>
          </p>
          <p>
            Il doit réussir un test théorique (≥ 45/50) puis une journée d’essai pratique avant d’être confirmé.
          </p>
          <hr>
          <p>
            Article 6 : Confidentialité
          </p>
          <p>
            <ol>
              <li>
                <span class="number">1. </span>
                Confidentialité de la plateforme et des technologies utilisées :
                <ol>
                  <li>
                    <span class="number">°</span>
                    La plateforme Oliverlist et les technologies utilisées 
                    pour la prospection sont strictement confidentielles.
                  </li>
                  <li>
                    <span class="number">°</span>
                    Le Booker s’engage à ne jamais divulguer, transmettre ou partager toute 
                    information relative aux méthodologies, processus ou technologies employées 
                    par Oliverlist, que ce soit durant ou après la fin de la collaboration.
                  </li>
                </ol>
              </li>
              <li>
                <span class="number">2. </span>
                Confidentialité des clients d’Oliverlist :
                <ol>
                  <li>
                    <span class="number">°</span>
                    Le Booker s’engage à respecter la plus stricte confidentialité 
                    concernant les clients d’Oliverlist.
                  </li>
                  <li>
                    <span class="number">°</span>
                    Il lui est formellement interdit de divulguer à un tiers des informations sur 
                    l’identité des clients, la nature de leurs activités ou les services fournis par Oliverlist.
                  </li>
                </ol>
              </li>
              <li>
                <span class="number">3. </span>
                Sanctions en cas de violation :
                <ol>
                  <li>
                    <span class="number">°</span>
                    Toute violation des obligations de confidentialité pourra entraîner une 
                    résiliation immédiate du contrat, sans préavis ni compensation.
                  </li>
                  <li>
                    <span class="number">°</span>
                    La Société se réserve le droit d’engager des poursuites judiciaires en 
                    cas de préjudice résultant d’une divulgation non autorisée.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
          <hr>
          <p>
            Article 7 : Résiliation
          </p>
          <p>
            <ol>
              <li>
                <span class="number">1) </span>
                Rémunération conditionnée aux résultats :
                <ol>
                  <li>
                    <span class="number">a) </span>
                      Le salaire fixe doit être activé :
                     <ol>
                        <li>
                          <span class="number">i.</span>
                            La rémunération du Booker est strictement conditionnée à la réalisation d’au moins <strong>un (1) meeting pris 
                            (les meetings ne respectant pas les conditions minimales établies le service de contrôle qualité ne comptent pas)</strong>
                            sur la période mensuelle en cours.
                        </li>
                        <li>
                          <span class="number">ii.</span>
                          À défaut de générer au moins un meeting durant le mois, <strong>aucune rémunération ne sera due</strong> par la Société au Booker pour ladite période.
                        </li>
                     </ol>
                  </li>
                </ol>
              </li>
            </ol>
          </p>
        </div>
        <div class="pdf-page-break"> <!-- pagina 4 -->
          <p>
            <ol>
              <li>
                <ol>
                  <li>
                    <span class="number">b)</span>
                      Une fois passé en Level 2, la condition précédente s’applique en plus des conditions suivantes de déblocage du salaire fixe : 
                      <ol>
                        <li>
                          <span class="number">i)</span>
                            Sans l’obtention d’au moins <strong>1 meeting validé</strong> dans le mois en cours, le salaire fixe sera calculé sur la base de 100€. 
                        </li>
                        <li>
                          <span class="number">ii)</span>
                            Dès l’obtention d’1 meeting validé dans le mois en cours, le salaire fixe sera calculé sur 50% du salaire 
                            fixe de référence correspondant au status du Booker.
                        </li>
                        <li>
                          <span class="number">iii)</span>
                            Dès l’obtention de 2 meetings validés dans le mois en cours, le salaire fixe sera calculé sur 100% du salaire 
                            fixe de référence correspondant au status du Booker.
                        </li>
                      </ol>
                      Un  <em>meeting validé</em> s’entend d’un rendez-vous commercial effectivement honoré par le client 
                      et par le prospect, et dûment facturé par la Société.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
          <p>
            <ol>
              <li>
                <span class="number">2. </span>
                Résiliation pour manque de résultats :
                <ol>
                  <li>
                    <span class="number">°</span>
                    Si le Booker ne génère <strong>aucun meeting validé durant un mois complet</strong>, la Société se réserve le droit de 
                    résilier ce contrat de manière anticipée, <strong>sans préavis ni indemnité</strong>.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
          <p>
            <ol>
              <li>
                <span class="number">3. </span>
                Manquements qualitatifs ou opérationnels :
                <ol>
                  <li>
                    <span class="number">°</span>
                    Indépendamment des résultats, en cas de non-respect des obligations d’assiduité, 
                    de la qualité des appels ou du respect des procédures internes, la Société pourra 
                    procéder à la résiliation du contrat <strong>sans préavis</strong>.
                  </li>
                </ol>
              </li>
              <li>
                <span class="number">4. </span>
                Résiliation à l’initiative du Booker :
                <ol>
                  <li>
                    <span class="number">°</span>
                    Le Booker peut résilier ce contrat avec un préavis de 15 jours.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
          <hr>
          <p>
            Article 8 : Dispositions Générales
          </p>
          <p>
            <ol>
              <li>
                <span class="number">1. </span>
                Statut du Booker :
                <ol>
                  <li>
                    <span class="number">°</span>
                    Le Booker agit en qualité de freelance et n’est pas lié à la Société par un contrat de travail.
                  </li>
                  <li>
                    <span class="number">°</span>
                    Il est responsable de ses propres déclarations fiscales et sociales.
                  </li>
                </ol>
              </li>
              <li>
                <span class="number">2. </span>
                Responsabilités en matière d'équipement :
                <ol>
                  <li>
                    <span class="number">°</span>
                    Le Booker est responsable de fournir et de financer sa propre connexion Internet 
                    et le matériel nécessaire à l'exécution de ses missions, incluant notamment un ordinateur, 
                    un casque audio et tout autre équipement requis.
                  </li>
                </ol>
              </li>
              <li>
                <span class="number">3. </span>
                Jours fériés :
                <ol>
                  <li>
                    <span class="number">°</span>
                    Le Booker a droit aux jours fériés français uniquement et n'est pas tenu de travailler durant ces jours.
                  </li>
                </ol>
              </li>
            </ol>
          </p>
          <hr>
        </div>
        <div class="pdf-page-break"> <!-- pagina 5 -->
          <p>
            Fait à Paris, le {{ formatDate(booker.date) }}.
          </p>
          <p>
            Pour VIVASYNC MARKETING CONSULTANCY :
          </p>
          <img src="@/assets/images/booker/firma_contrato_booker.png" class="pdf-firma">
          <p>
            Thibault Pons de Vincent
          </p>
          <p>
            Pour le Booker : {{ booker.nameBooker }}
          </p>

        </div>
        <!-- FIN FRANCES -->
      </div>
    </div>
  </template>
  <script>
  import { mapState } from "vuex";
  import moment from "moment";
  
  export default {
    props: {
      booker: {
        type: Object,
        required: true
      }
    },
    data(){
      return{
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        date: '',
        nameBooker: '',
        bookerStatus: '',
      }
    },
    computed: {
      ...mapState({
        user: (state) => state.authentication.user,
      }),
    },
    methods: {
      formatDate(date) {
        if(!date) return '';
        return date.split(" ")[0];
      },
    },
  };
  </script>
  
  <style scoped>
    /* .pdf-container .pdf-page-break {
    position: relative;
    height: 1000px;
  }
  .pdf-container .pdf-page-break:before {
    display: block;
    content: "";
    position: absolute;
    border: solid 3px red;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    height: 1000px;
  } */
  #pdf-content {
    width: 210mm; /* Ancho de A4 en milímetros */
    height: auto; /* Deja que la altura sea dinámica */
    margin: 0 auto; /* Centra el contenido */
  }
  @media print, screen {
    #pdf-content {
      width: 800px;
      margin: 0 auto;
    }
  }
  .pdf-container {
    font-size: 16px;
    padding: 20px;
    line-height: 1.5;
  }
  .pdf-container .pdf-page-break {
    position: relative;
    padding-top: 40px;
  }
  .pdf-container .table-header {
    padding: 0px 20px 40px 20px;
  }
  .pdf-container h1 {
    font-size: 1em;
    background: #5054EB;
    color: #ffffff;
    padding: 10px 20px;
    margin-bottom: 20px;
    text-align: center;
    position: relative;
  }
  .pdf-container .pdf-firma {
    width: 15%;
    margin-right: 550px;
  }
  .pdf-container h1 span {
    font-size: 0.9em;
    position: absolute;
    left: 20px;
    text-align: left;
  }
  .pdf-container h2 {
    font-size: 0.85em;
    border-bottom: 2px solid;
    margin: 0px 15px 20px 15px;
    padding: 10px;
  }
  .pdf-container h3 {
    font-size: 0.8em;
    padding: 10px;
    margin: 0px 15px 0px 15px;
  }
  .pdf-container h4 {
    text-align: center;
  }
  .pdf-container p {
    font-size: 0.78em;
    margin-bottom: 10px;
    padding: 0px 30px;
    text-align: justify;
  }
  .pdf-container ol,
  .pdf-container li {
    margin: 0;
    padding: 0;
  }
  .pdf-container ol {
    counter-reset: foo;
    display: table;
    margin-bottom: 20px;
    margin-left: 20px;
  }
  .pdf-container li {
    list-style: none;
    counter-increment: foo;
    display: table-row;
  }

  .pdf-container hr {
    width: 75%;
    height: 1px;              
    background-color: black; 
    border: none;
    margin: 2rem auto 2rem auto;             
  }
  
  /* li::before {
    content: counter(foo) ".";
    display: table-cell;
    text-align: right;
    padding-right: 0.3em;
    color: transparent;
  } */
  
  .pdf-container li span.number {
    display: table-cell;
    text-align: right;
    padding-right: 0.3em;
  }
  .pdf-container li span.text {
    display: table-cell;
    text-align: left;
    padding-right: 0.3em;
  }
  </style>